export const DEBUG_ACTIONS = [
  {
    custom: false,
    icon: 'keyboard_arrow_up',
    action: 'next-command',
    tooltip: 'Next',
    color: 'primary',
    aria: 'next command',
    testId: 'next-command'
  },
  {
    custom: false,
    icon: 'keyboard_arrow_down',
    action: 'previous-command',
    tooltip: 'Previous',
    color: 'primary',
    aria: 'previous command',
    testId: 'previous-command'
  },
  {
    icon: 'backspace',
    action: 'clear-console',
    tooltip: 'clear console',
    color: 'primary',
    aria: 'clear console',
    testId: 'clear-console'
  },
];
